<template>
  <Slidebar @closeMe="closeSlidebar" :large="true">
    <h4>{{ item.heiti }} - {{ item.kodi }}</h4>
    <table class="table less-padding no-border">
      <tr>
        <th>Stofnað</th>
        <td>{{ item.time_create | moment('DD.MM.YYYY HH:mm:ss') }}</td>
      </tr>
      <tr>
        <th>Stofnað af</th>
        <td>{{ item.stofnad_af_nafn }}</td>
      </tr>
      <tr>
        <th>Síðast breytt</th>
        <td>{{ item.time_edit | moment('DD.MM.YYYY HH:mm:ss') }}</td>
      </tr>
      <tr>
        <th>Breytt af</th>
        <td>{{ item.breytt_af_nafn }}</td>
      </tr>
    </table>
    <h5>Færslur úr dagbók</h5>
    <i> Ath. eftirfarandi færslur fundust í dagbók fyrir kóða námsgreinar. </i>
    <div v-if="list.length === 0 && !loading" class="mt-4">Engar færslur fundust í dagbók</div>
    <table class="table table-hover less-padding no-border" style="font-size: 13px" v-if="list.length > 0">
      <thead>
        <tr>
          <th>Dags.</th>
          <th>Breytt af</th>
          <th>Aðgerð</th>
          <th>Svæði</th>
          <th>Atriði</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in list" :key="idx">
          <td style="white-space: nowrap">{{ item.dags | moment('DD.MM.YYYY HH:mm:ss') }}</td>
          <td style="white-space: nowrap">{{ item.nafn }}</td>
          <td>{{ item.adgerd_heiti }}</td>
          <td>{{ item.svaedi }}</td>
          <td>{{ item.atridi }}</td>
        </tr>
      </tbody>
    </table>
  </Slidebar>
</template>

<script>
import common from '@/api/common';
import { mapActions, mapGetters } from 'vuex';

import Slidebar from '@/components/common/Slidebar.vue';

export default {
  name: 'subject-history',
  props: ['item'],
  components: {
    Slidebar,
  },
  computed: {
    canEdit() {
      return this.loggedInUserHasWritePermission('namskra_namsgreinar');
    },
    ...mapGetters(['loggedInUserHasReadPermission', 'loggedInUserHasWritePermission']),
  },
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  methods: {
    closeSlidebar() {
      this.$emit('closeSlidebar');
    },
    async loadList() {
      this.loading = true;
      this.list = [];
      try {
        const response = await common.getDiary('Námsgreinar', { search: `Kodi=${this.item.kodi}` });

        this.list = response.data.items.map(x => ({
          ...x,
          svaedi: x.svaedi ? x.svaedi.replaceAll(',', ', ') : '',
          atridi: x.atridi ? x.atridi.replaceAll(',', ', ') : '',
        }));
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  watch: {
    item() {
      this.loadList();
    },
  },
  created() {
    this.loadList();
  },
};
</script>

<style lang="scss"></style>
